export default "__VITE_ASSET__RwOfAIyL__"